<template>
  <section class="home-faq" id="home-faq">
    <div class="faq-decor faq-decor--left">
      <img v-lazy="require('../../../static/images/home/faq-book-left.jpg')" alt="">
    </div>
    <div class="faq-decor faq-decor--right">
      <img v-lazy="require('../../../static/images/home/faq-book-right.jpg')" alt="">
    </div>
    <header>
      <h2>{{ $t('home.faqTitle') }}</h2>
      <p class="subtitle">{{ $t('home.faqSubTitle') }}</p>
    </header>
    <div class="faq-list">
      <div class="faq-item" v-for="(item, index) in faqItems" :key="index"
           :class="{ open: openIndex === index }" @click="toggle(index)">
        <div class="faq-question">
          <i :class="['fa', item.icon, 'faq-q-icon']"></i>
          <span>{{ item.q }}</span>
          <svg class="faq-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <div class="faq-answer" v-show="openIndex === index">
          <p>{{ item.a }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeFAQ',
  data () {
    return {
      openIndex: 0
    }
  },
  computed: {
    faqItems () {
      return [
        { q: this.$t('home.faq1Q'), a: this.$t('home.faq1A'), icon: 'fa-truck' },
        { q: this.$t('home.faq2Q'), a: this.$t('home.faq2A'), icon: 'fa-dollar' },
        { q: this.$t('home.faq3Q'), a: this.$t('home.faq3A'), icon: 'fa-diamond' },
        { q: this.$t('home.faq4Q'), a: this.$t('home.faq4A'), icon: 'fa-users' },
        { q: this.$t('home.faq5Q'), a: this.$t('home.faq5A'), icon: 'fa-share-alt' },
        { q: this.$t('home.faq6Q'), a: this.$t('home.faq6A'), icon: 'fa-paint-brush' },
        { q: this.$t('home.faq7Q'), a: this.$t('home.faq7A'), icon: 'fa-shield' }
      ]
    }
  },
  methods: {
    toggle (index) {
      this.openIndex = this.openIndex === index ? -1 : index
    }
  }
}
</script>

<style lang="scss">
.home-faq {
  padding: 5rem 1.5rem;
  background-color: #f8f9fc;
  position: relative;
  overflow: hidden;

  .faq-decor {
    position: absolute;
    bottom: 0;
    width: 320px;
    pointer-events: none;
    z-index: 0;

    img {
      width: 100%;
      height: auto;
      display: block;
      opacity: 0.35;
      border-radius: 8px;
    }

    // 从中间向上下白色弥散遮罩
    &--left {
      left: -40px;
      top: 50%;
      transform: rotate(-12deg) translateY(-50%);

      &::after {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background: radial-gradient(ellipse at center, transparent 0%, transparent 20%, rgba(248, 249, 252, 0.7) 55%, rgba(248, 249, 252, 0.95) 80%);
        border-radius: 8px;
        z-index: 1;
      }

      &::before {
        content: '';
        position: absolute;
        top: -60%; left: -50%; right: -50%; bottom: -60%;
        background: radial-gradient(ellipse at center, rgba(200, 180, 240, 0.7) 0%, rgba(180, 210, 255, 0.4) 35%, transparent 65%);
        filter: blur(40px);
        z-index: -1;
      }
    }

    &--right {
      right: -40px;
      top: 50%;
      transform: rotate(10deg) translateY(-50%);

      &::after {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background: radial-gradient(ellipse at center, transparent 0%, transparent 20%, rgba(248, 249, 252, 0.7) 55%, rgba(248, 249, 252, 0.95) 80%);
        border-radius: 8px;
        z-index: 1;
      }

      &::before {
        content: '';
        position: absolute;
        top: -60%; left: -50%; right: -50%; bottom: -60%;
        background: radial-gradient(ellipse at center, rgba(170, 230, 220, 0.65) 0%, rgba(180, 240, 210, 0.35) 35%, transparent 65%);
        filter: blur(40px);
        z-index: -1;
      }
    }
  }

  header, .faq-list {
    position: relative;
    z-index: 1;
  }

  .faq-list {
    max-width: 800px;
    margin: 0 auto;
  }

  .faq-item {
    background: #fff;
    border-radius: 10px;
    margin-bottom: 0.75rem;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    &.open {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
  }

  .faq-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem 1.5rem;
    font-weight: 600;
    font-size: 1.125rem;
    color: #1a1a2e;
    gap: 1rem;

    .faq-q-icon {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      background: rgba(81, 45, 202, 0.08);
      color: $el-color-primary;
      font-size: 14px;
    }

    span {
      flex: 1;
    }
  }

  .faq-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: #9ca3af;
    transition: transform 0.25s;
  }

  .faq-item.open .faq-icon {
    transform: rotate(180deg);
    color: $el-color-primary;
  }

  .faq-answer {
    padding: 0 1.5rem 1.25rem 4.5rem;

    p {
      font-size: 1rem;
      color: #6b7280;
      line-height: 1.7;
      margin: 0;
    }
  }
}

@media (max-width: 768px) {
  .home-faq {
    padding: 3.5rem 1rem;

    .faq-decor {
      display: none;
    }

    .faq-question {
      padding: 1rem 1.25rem;
      font-size: 0.9375rem;
    }

    .faq-answer {
      padding: 0 1.25rem 1rem;

      p {
        font-size: 0.875rem;
      }
    }
  }
}
</style>
